// //venus// Força negrito + centro + h2 size no título do widget Judge.me via inline style (vence qualquer CSS interno do widget).
(function () {
  if (typeof window === 'undefined') return;

  var applyStyles = function (el) {
    if (!el) return;
    el.style.setProperty('font-family', 'var(--font-heading-family)', 'important');
    el.style.setProperty('font-weight', '600', 'important');
    el.style.setProperty('text-align', 'left', 'important');
    var isDesktop = window.innerWidth >= 750;
    el.style.setProperty(
      'font-size',
      isDesktop ? 'calc(var(--font-heading-scale, 1) * 2.4rem)' : 'calc(var(--font-heading-scale, 1) * 2rem)',
      'important'
    );
    el.style.setProperty('margin', isDesktop ? '0 0 3.2rem' : '0 0 2.4rem', 'important');
    el.style.setProperty('display', 'block', 'important');
    el.style.setProperty('line-height', '1.2', 'important');
    el.style.setProperty('letter-spacing', 'calc(var(--font-heading-scale, 1) * 0.06rem)', 'important');
    el.style.setProperty('color', 'rgb(var(--color-foreground))', 'important');
  };

  var TITLE_SELECTOR = '.jm-review-widget-minimal-header__title, .jdgm-rev-widg__title';

  var styleAll = function () {
    document.querySelectorAll(TITLE_SELECTOR).forEach(applyStyles);
  };

  // Initial pass after DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', styleAll);
  } else {
    styleAll();
  }

  // Watch for Judge.me widget injection (async)
  var observer = new MutationObserver(function (mutations) {
    var found = false;
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (
          node.classList &&
          (node.classList.contains('jdgm-rev-widg__title') ||
            node.classList.contains('jm-review-widget-minimal-header__title'))
        ) {
          applyStyles(node);
          found = true;
        } else if (node.querySelector) {
          var titles = node.querySelectorAll(TITLE_SELECTOR);
          if (titles.length) {
            titles.forEach(applyStyles);
            found = true;
          }
        }
      }
    }
    if (!found) return;
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Reapply on resize (font-size depends on viewport)
  window.addEventListener('resize', styleAll);
})();
